import { useState, useEffect } from "react";
import { useUser } from "src/shared/context/UserContext";
import { getCustomer } from "src/shared/services/servicesv2";
import { CustomerData } from "src/shared/services/interfacev2";

export const useCustomerManagement = () => {
  const [customers, setCustomers] = useState<CustomerData[]>([]);
  const [filteredCustomers, setFilteredCustomers] = useState<CustomerData[]>([]);
  const [pagenumber, setPagenumber] = useState<number>(1);
  const { userConfigration } = useUser();
  const [pageSize] = useState<number>(userConfigration?.tableDefaultSize || 10);
  const [total, setTotal] = useState({
    totalRecords: "",
    totalPage: "",
  });
  
  // Update to separate name fields
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [tableNumber, setTableNumber] = useState("");
  const [customerAdd, setCustomerAdd] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const fetchCustomerDetails = async () => {
    try {
      const response = await getCustomer(false, pagenumber, pageSize, searchTerm);
      const data = response.data;

      setCustomers(response.data.customer_details || []);
      setFilteredCustomers(response.data.customer_details || []);
      setTotal({
        totalRecords: data.totalRecords,
        totalPage: String(Math.ceil(Number(data.totalRecords) / pageSize)),
      });
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  // Add this effect to trigger API call when searchTerm changes
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchCustomerDetails();
    }, 500); // Debounce search

    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, pagenumber]);

  // Helper function to get full name from fields
  const getFullName = () => {
    return `${firstName || ""} ${middleName || ""} ${lastName || ""}`.trim() || "-";
  };

  // Helper function to reset customer fields
  const resetCustomerFields = () => {
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setPhoneNumber("");
    setTableNumber("");
  };

  return {
    customers,
    filteredCustomers,
    setFilteredCustomers,
    pagenumber,
    setPagenumber,
    total,
    firstName,
    setFirstName,
    middleName,
    setMiddleName,
    lastName,
    setLastName,
    phoneNumber,
    setPhoneNumber,
    tableNumber,
    setTableNumber,
    customerAdd,
    setCustomerAdd,
    searchTerm,
    setSearchTerm,
    fetchCustomerDetails,
    pageSize,
    getFullName,
    resetCustomerFields,
  };
};